module.exports = __webpack_public_path__ + "static/media/SuisseIntl-SemiBold-WebS.d66fe0c4.svg";